export default __webpack_public_path__ + "i18n/ro.338387e986537adbb49df619fab241be.json";